import { ChangeDetectionStrategy, Component, Inject, OnInit, signal } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MaintenanceViewModel } from "src/app/core";
import { MaintenanceService } from "src/app/services/maintenance.service";

@Component({
  selector: "brd-maintenance-popup",
  templateUrl: "./maintenance-popup.component.html",
  styleUrl: "./maintenance-popup.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MaintenancePopupComponent implements OnInit {
  maintenanceForm = new FormGroup({
    startDate: new FormControl<Date>(undefined, Validators.required),
    startHour: new FormControl<Date>(undefined, Validators.required),
    endDate: new FormControl<Date>(undefined, Validators.required),
    endHour: new FormControl<Date>(undefined, Validators.required),
    alertShowDate: new FormControl<Date>(undefined)
  });

  maintenanceId = signal(0);
  customAlertShowDate = signal(false);
  minDate = new Date();
  timeZoneInfo = `Already adjusted in your local timezone.`;

  constructor(
    private dialogRef: MatDialogRef<MaintenanceViewModel>,
    @Inject(MAT_DIALOG_DATA) public data: MaintenanceViewModel,
    private readonly maintenanceService: MaintenanceService
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.maintenanceId.set(this.data.id ?? 0);
      this.customAlertShowDate.set(!!this.data.alertShowDate);
      this.maintenanceForm.setValue({
        startDate: this.data.startDate ? new Date(this.data.startDate) : null,
        startHour: this.data.startDate ? new Date(this.data.startDate) : null,
        endDate: this.data.endDate ? new Date(this.data.endDate) : null,
        endHour: this.data.endDate ? new Date(this.data.endDate) : null,
        alertShowDate: this.data.alertShowDate ? new Date(this.data.alertShowDate) : null
      });
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  createMaintenance(): void {
    if (this.maintenanceForm.valid) {
      const values = this.maintenanceForm.value;
      const startHour = new Date(values.startHour);
      const endHour = new Date(values.endHour);

      const startDate = new Date(values.startDate);
      startDate.setHours(startHour.getHours());
      startDate.setMinutes(startHour.getMinutes());

      const endDate = new Date(values.endDate);
      endDate.setHours(endHour.getHours());
      endDate.setMinutes(endHour.getMinutes());

      const maintenance: MaintenanceViewModel = {
        id: this.maintenanceId(),
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        alertShowDate: this.customAlertShowDate() ? new Date(values.alertShowDate).toISOString() : undefined,
        isActive: false
      };

      this.maintenanceService.updateMaintenance(maintenance).subscribe({
        next: createdMaintenance => {
          this.dialogRef.close(createdMaintenance);
        }
      });
    }
  }

  deleteMaintenance(): void {
    if (this.maintenanceId()) {
      this.maintenanceService.removeMaintenance(this.maintenanceId()).subscribe({
        next: () => {
          this.dialogRef.close();
        }
      });
    }
  }
}
